exports.decode = decode
exports.isTokenExpired = isTokenExpired

function decode(t) {
	let token = {};
	token.raw = t;
	token.header = JSON.parse(window.atob(t.split('.')[0].replace(/-/g, "+").replace(/_/g, "/")));
	token.payload = JSON.parse(window.atob(t.split('.')[1].replace(/-/g, "+").replace(/_/g, "/")));
	return (token)
}

function isTokenExpired(token) {
	const decodedToken = decode(token);

	const { payload } = decodedToken

	if (!payload || !payload.exp)
		return true;

	const expirationTime = payload.exp * 1000;

	const currentTime = new Date().getTime();

	return currentTime > expirationTime;
}